import { useDispatch } from "react-redux";
import { getCookieDetails } from "Auth/authActions";
import { setUserDetail } from "features/userDetails/userDetailsSlice";
import { setCompanyAccessDetail } from "features/userDetails/companyAccessSlice";
import { setUserRoles } from "features/userDetails/usersRolesSlice";
import { setIsViewer, setLoginFlag } from "features/auth/authSlice";

import { useEffect, useState } from "react";
import { message } from "constants/responses/message";
import { userDetailsApi } from "API/apis/user/userDetails";
import { companyDetailsApi } from "API/apis/user/companyDetails";
import { userRolesApi } from "API/apis/user/userRoles";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useModuleAccessNavContext } from "context/ModuleAccessNavContext";
import { systemConfigApi } from "API/apis/systemConfig/systemConfig";

export const useStoreUserDetails = () => {
  const [loading, setLoading] = useState(true);
  const [initializing, setInitializing] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const isValidCookie = getCookieDetails();
  const { setNavItems, setAccessCodeMap } = useModuleAccessNavContext();

  useEffect(() => {
    if (isValidCookie) {
      const fetchAndDispatchData = async () => {
        setLoading(true);

        try {
          let errorString = [];
          let isError = false;
          const promises = [
            userDetailsApi(),
            companyDetailsApi(),
            userRolesApi(),
            systemConfigApi(),
          ];
          const [
            { data: userData, status: userDataStatus },
            { data: companyDetails, status: companyDetailsStatus },
            { data: rolesDetails, status: rolesDetailsStatus },
            { data: configData, status: configStatus },
          ] = await Promise.all(promises);

          const { isViewer } = userData;

          if (configStatus !== STATUS_CODES.SUCCESS) {
            errorString.push(message.error.generalFailure);
            isError = true;
          }

          if (userDataStatus !== STATUS_CODES.SUCCESS) {
            errorString.push(message.error.userDetails);
            isError = true;
          }

          if (companyDetailsStatus !== STATUS_CODES.SUCCESS) {
            errorString.push(message.error.companyDetails);
            isError = true;
          }

          if (rolesDetailsStatus !== STATUS_CODES.SUCCESS) {
            errorString.push(message.error.userRoles);
            isError = true;
          }
          if (!isError) {
            dispatch(setUserDetail(userData));
            dispatch(setCompanyAccessDetail(companyDetails[0]));
            dispatch(setUserRoles(rolesDetails));
            dispatch(setLoginFlag(true));
            dispatch(setIsViewer(isViewer));
            setNavItems(configData.modules);
            setAccessCodeMap(configData.accessCodeMap);

            setLoading(false);
          } else {
            throw new Error(errorString.join("<br />"));
          }
        } catch (error) {
          setLoading(false);
          setError(error.message);
        } finally {
          setLoading(false);
          setInitializing(false);
        }
      };
      fetchAndDispatchData();
    } else {
      setError(message.error.somethingWentWrong);
      setLoading(false);
      setInitializing(false);
    }
  }, [dispatch, isValidCookie]);
  return { error, loading, initializing };
};
